import { Button } from './button';

interface ErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

// Default full-screen fallback for a SentryErrorBoundary (from @loop3/observability).
// Lives here so its theme classes are picked up by every app's Tailwind @source scan.
export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <pre className="max-w-lg whitespace-pre-wrap rounded bg-muted p-4 text-xs">
        {error.message}
      </pre>
      <Button variant="outline" onClick={resetError}>
        Try again
      </Button>
    </div>
  );
}
